import React, { useEffect, useRef } from 'react';
import { LuCopy, LuPencil, LuTrash2 } from 'react-icons/lu';

interface ProductGroupOptionsPopoverProps {
	anchorRef: React.RefObject<HTMLElement | null>;
	onRename(): void;
	onCopy(): void;
	onDelete(): void;
	onClose(): void;
}

export function ProductGroupOptionsPopover({
	anchorRef,
	onRename,
	onCopy,
	onDelete,
	onClose,
}: ProductGroupOptionsPopoverProps) {
	const popoverRef = useRef<HTMLDivElement>(null);

	const handleClickOutside = (event: MouseEvent) => {
		const target = event.target as Node;

		if (
			popoverRef.current &&
			!popoverRef.current.contains(target) &&
			anchorRef.current &&
			!anchorRef.current.contains(target)
		) {
			onClose();
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div
			ref={popoverRef}
			data-testid='popover'
			className='absolute left-1/2 -translate-x-1/2 mt-0.5 w-24 bg-white rounded border border-gray-300 shadow-lg z-20'
		>
			<span className='absolute -top-[5px] left-1/2 -translate-x-1/2 w-2 h-2 bg-white border-t border-l border-gray-300 rounded-sm rotate-45 z-[-1]'></span>
			<div className='flex flex-col overflow-hidden rounded'>
				<button
					onClick={(e) => {
						e.stopPropagation();
						onCopy();
					}}
					className='flex items-center gap-2 px-2.5 py-2 text-[12px] font-semibold text-gray-700 hover:bg-cPurple-600 hover:text-white transition-colors border-b border-gray-100 last:border-none'
				>
					<LuCopy className='w-3.5 h-3.5' />
					Copy
				</button>
				<button
					onClick={(e) => {
						e.stopPropagation();
						onRename();
					}}
					className='flex items-center gap-2 px-2.5 py-2 text-[12px] font-semibold text-gray-700 hover:bg-black hover:text-white transition-colors border-b border-gray-100 last:border-none'
				>
					<LuPencil className='w-3.5 h-3.5' />
					Rename
				</button>
				<button
					onClick={(e) => {
						e.stopPropagation();
						onDelete();
					}}
					className='flex items-center gap-2 px-2.5 py-2 text-[12px] font-semibold text-red-600 hover:bg-red-600 hover:text-white transition-colors'
				>
					<LuTrash2 className='w-3.5 h-3.5' />
					Delete
				</button>
			</div>
		</div>
	);
}
